var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Checkbox, Col, Row } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { AccordionSection } from "../../../AccordionSection";
import { RecekTextField } from "../../../inputs";
export var PricingSection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle, _b = _a.chargeForIsbn, chargeForIsbn = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(AccordionSection, { id: "progress-report-pricing", labelId: "ui-br-agency.outputs.progress-report.section.pricing", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "chargeForIsbn", render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (React.createElement(Checkbox, { label: formatMessage({
                                id: "ui-br-agency.outputs.progress-report.field.chargeForIsbn",
                            }), checked: value, onChange: function (e) {
                                return onChange(e.target.checked);
                            } }));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "pricePerIsbn", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.pricePerIsbn", disabled: !chargeForIsbn })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "priceFor10", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.priceFor10", disabled: !chargeForIsbn })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "priceFor100", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.priceFor100", disabled: !chargeForIsbn })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "priceFor1000", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.priceFor1000", disabled: !chargeForIsbn })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "annualMembership", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.annualMembership", disabled: !chargeForIsbn })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "registrationFee", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.registrationFee", disabled: !chargeForIsbn })));
                    } })))));
};
